import { c as _c } from "react/compiler-runtime";
import type { ReactNode, JSX } from 'react';
import { Children } from 'react';
import styled from 'styled-components';
import { colors } from '../../theme/colors';
import { IconWarning } from '../icons';
import { Input } from '../input';
import { CircleSpinner } from '../spinner';
import { Text } from '../text';
interface Props {
  loading?: boolean;
  error?: string | null;
  placeholder: string;
  searchPlaceholder?: string;
  searchInput?: string;
  onSearchInputChange: (value: string) => void;
  children?: ReactNode;
  containerHeight?: number;
}

/**
 * This component is deprecated. Use `Selectable` instead.
 * @deprecated Use Selectable component.
 */
export default function ObjectSelector(t0) {
  const $ = _c(26);
  const {
    loading: t1,
    error,
    placeholder,
    children,
    searchPlaceholder: t2,
    searchInput,
    onSearchInputChange,
    containerHeight: t3
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const searchPlaceholder = t2 === undefined ? "Filter by keyword" : t2;
  const containerHeight = t3 === undefined ? 380 : t3;
  const hasChildren = !!children && Children.count(children) > 0;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      borderLeft: 0,
      borderRight: 0,
      borderRadius: 0,
      marginTop: -1,
      boxShadow: "none",
      paddingLeft: 40
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== onSearchInputChange || $[2] !== searchInput || $[3] !== searchPlaceholder) {
    t5 = <Input type="search" placeholder={searchPlaceholder} style={t4} value={searchInput} onChange={onSearchInputChange} />;
    $[1] = onSearchInputChange;
    $[2] = searchInput;
    $[3] = searchPlaceholder;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== containerHeight) {
    t6 = {
      height: containerHeight,
      overflowY: "auto",
      background: colors.steel[100],
      paddingBottom: 16,
      position: "relative"
    };
    $[5] = containerHeight;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== loading) {
    t7 = loading && <CircleSpinner />;
    $[7] = loading;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== error || $[10] !== loading) {
    t8 = !loading && error && <Centered><IconWarning /><Text color="default">{error}</Text></Centered>;
    $[9] = error;
    $[10] = loading;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== error || $[13] !== hasChildren || $[14] !== loading || $[15] !== placeholder) {
    t9 = !hasChildren && !error && !loading && <Centered><Text color="default">{placeholder}</Text></Centered>;
    $[12] = error;
    $[13] = hasChildren;
    $[14] = loading;
    $[15] = placeholder;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== children || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div style={t6}>{t7}{t8}{children}{t9}</div>;
    $[17] = children;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t5) {
    t11 = <div>{t5}{t10}</div>;
    $[23] = t10;
    $[24] = t5;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
const Centered = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  max-width: 520;
`;